import React from 'react'
import { ObjectSelection } from '../components'
import { StepComponentProps, MilitaryObject, ObjectGroup } from '../types'

type ObjectSelectionStepProps = StepComponentProps

const ObjectSelectionStep: React.FC<ObjectSelectionStepProps> = ({ stepData, onNext }) => {
  const handleObjectSelection = (groups: ObjectGroup[], selectedObjects: MilitaryObject[]) => {
    onNext({
      objects: selectedObjects,
      groups: groups,
    })
  }

  return <ObjectSelection onNext={handleObjectSelection} />
}

export default ObjectSelectionStep
